@use './spinner-utility';
@use './spinner-vars';
@use './spinner-common';

:host {
  @include spinner-vars.wb-spinner-vars;
  @include spinner-common.wb-spinner;

  .inner {
    @include spinner-common.wb-spinner-inner;
  }
}

:host([paused]) .inner {
  @include spinner-common.wb-spinner-paused;
}

:host([data-on-brand]) {
  @include spinner-vars.wb-spinner-on-brand-vars;
}

:host([size='l']) {
  @include spinner-vars.wb-spinner-large-vars;
}

:host([size='m']) {
  @include spinner-vars.wb-spinner-medium-vars;
}

:host([size='s']) {
  @include spinner-vars.wb-spinner-small-vars;
}
